module.exports = __webpack_public_path__ + "static/img/4-CN.2bf1171.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_m/4-CN.png
// module id = jYVw
// module chunks = 1